import Repository from './Repository';
const resource = '/products/detail';

export default {
  get() {
    return Repository.get(`${resource}`);
  }
};
